import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Login pages.
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { HomeComponent } from './home/home.component';

// Account pages.
import { MyAccountComponent } from './my-account/my-account.component';
import { MyPasswordComponent } from './my-password/my-password.component';


// Administration pages.
import { FolderListComponent } from './folder-list/folder-list.component';
import { CompanyListComponent } from './company-list/company-list.component';
import { CompanyDetailComponent } from './company-detail/company-detail.component';
import { UserListComponent } from './user-list/user-list.component';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { FolderDetailAdminComponent } from './folder-detail-admin/folder-detail-admin.component';

// Folders pages.
import { FolderDetailComponent } from './folder-detail/folder-detail.component';

// Misc pages.
import { InfosComponent } from './infos/infos.component';

const routes: Routes = [
  // Login / Logout / Home page.
  {path: 'login', component: LoginComponent},
  {path: 'logout', component: LogoutComponent},
  {path: 'home', component: HomeComponent},
  {path: 'my-account', component: MyAccountComponent},
  {path: 'my-password', component: MyPasswordComponent},

  // Admin: Folders.
  {path: 'folder-list', component: FolderListComponent},
  {path: 'folder-detail-admin/:id', component: FolderDetailAdminComponent},

  // Admin: Companies.
  {path: 'company-list', component: CompanyListComponent},
  {path: 'company-detail/:id', component: CompanyDetailComponent},

  // Admin: Users.
  {path: 'user-list', component: UserListComponent},
  {path: 'user-detail/:id', component: UserDetailComponent},

  // Folders.
  {path: 'folder-detail/:id', component: FolderDetailComponent},

  // Misc fields.
  {path: 'infos/:infoid/:param1/:param2/:param3', component: InfosComponent},

  {path: '', redirectTo: '/home', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
